import { Achievements } from "@components/Layouts/Tm90/Achievements";
import { Tm90Articles } from "@components/Layouts/Tm90/Tm90Articles";
import Tm90Header from "@components/Layouts/Tm90/Tm90Header";
import TmBanner from "@components/Layouts/Tm90/TmBanner";
import WelcomeBanner from "@components/Layouts/Tm90/WelcomeBanner";
import { TM90_HISTORY } from "@config/Tm90Constants";
import GAData from "@elements/GAData/GAData";
import MetaTags from "@elements/MetaTags/MetaTags";
import { Footer } from "@footer/Footer";
import useOKTAUserInfo from "@hooks/useOktaUserInfo";
import useRemoveOverlay from "@hooks/useRemoveOverlay";
import useScript from "@hooks/useScript";
import { AboutTmHistory } from "@pages/AboutUs/AboutTmHistory";
import ErrorPage from "@pages/ErrorPage";
import NotFound from "@pages/NotFound";
import {
  CustomContext,
  ResponseType,
  TRouteWithoutRedirect,
  useRouteContext,
} from "@sphtech/web2-core/ssr";
import type { ReactElement } from "react";

import { Tm90PayloadResponseType } from "./Tm90.server";
import { Tm90MetaData } from "./Tm90MetaData";

export default function Tm90(): ReactElement {
  useRemoveOverlay();
  useOKTAUserInfo();
  useScript({
    id: "mysph-lightbox-lib",
    src: import.meta.env.VITE_SPH_LIGHTBOX as string,
  });
  const routeContext: CustomContext<
    TRouteWithoutRedirect<Tm90PayloadResponseType, string>
  > = useRouteContext();
  const dataLoaderResponse = routeContext.context;
  if (dataLoaderResponse.type === ResponseType.CLIENT_ERROR) {
    return <NotFound />;
  } else if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  const tm90Articles = dataLoaderResponse.payload.data;
  const tagAlias = dataLoaderResponse.payload.tagAlias;
  const tmRecordedVideo = dataLoaderResponse.payload.tmRecordedVideo;
  const tmRecordedVideoPlaylist =
    dataLoaderResponse.payload.tmRecordedVideoPlaylist;

  const { gaData, metaTags } = Tm90MetaData();
  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <GAData {...gaData} />
        <MetaTags {...metaTags} />

        <Tm90Header />
        <Achievements
          tm90Video={tmRecordedVideo}
          tm90VideoPlaylist={tmRecordedVideoPlaylist}
        />
        <div className="bg-orange-600">
          <WelcomeBanner />
        </div>
        <AboutTmHistory data={TM90_HISTORY} />
        <div className="m-auto max-w-[1280px]">
          <Tm90Articles
            articles={tm90Articles}
            tagAlias={`/keywords/${tagAlias}`}
          />
        </div>
        <div className="bg-pink-1000">
          <TmBanner />
          <Footer />
        </div>
      </div>
    </>
  );
}
